import { createRouter, createWebHistory } from 'vue-router'
import { ROUTE_NAMES } from '@/config/routes'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: ROUTE_NAMES.HOME,
    component: () => import('@/pages/home/Home.vue'),
    meta: {
      title: 'Poseidonie'
    }
  },
  {
    path: '/services',
    name: ROUTE_NAMES.SERVICES,
    component: () => import('@/pages/services/Services.vue'),
    meta: {
      title: 'Design Service - Poseidonie'
    }
  },
  {
    path: '/projects',
    name: ROUTE_NAMES.PROJECTS,
    component: () => import('@/pages/projects/Projects.vue'),
    meta: {
      title: 'Projects - Poseidonie'      
    }
  },
  {
    path: '/contact',
    name: ROUTE_NAMES.CONTACT,
    component: () => import('@/pages/contact/ContactSection.vue'),
    meta: {
      title: 'Contact - Poseidonie'
    }
  },
  {
    path: '/projects/nouar',
    name: ROUTE_NAMES.NOUAR,
    component: () => import('@/pages/projects/Nouar.vue'),

  },
  {
    path: '/projects/azahar',
    name: ROUTE_NAMES.AZAHAR,
    component: () => import('@/pages/projects/Azahar.vue'),
    
  },
  {
    path: '/projects/tossalet',
    name: ROUTE_NAMES.TOSSALET,
    component: () => import('@/pages/projects/Tossalet.vue'),
    
  },
  {
    path: '/projects/sierra',
    name: ROUTE_NAMES.SIERRA,
    component: () => import('@/pages/projects/Sierra.vue'),
    
  },
  {
    path: '/projects/bellaombra',
    name: ROUTE_NAMES.BELLAOMBRA,
    component: () => import('@/pages/projects/Bellaombra.vue'),
    
  },
  {
    path: '/projects/wabi-sabi',
    name: ROUTE_NAMES.WABI_SABI,
    component: () => import('@/pages/projects/WabiSabi.vue'),
    
  },
  {
    path: '/:pathMatch(.*)*',
    name: ROUTE_NAMES.NOT_FOUND,
    component: () => import('@/components/general/NotFound.vue'),
    meta: {
      title: 'Página no encontrada'
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Navigation guards
router.beforeEach((to, _from, next) => {
  // Set page title
  if (to.meta?.title) {
    document.title = to.meta.title as string
  }
  
  next()
})

export default router